import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=19c1eafc&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"
import style0 from "./Footer.vue?vue&type=style&index=0&id=19c1eafc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c1eafc",
  null
  
)

export default component.exports